/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Break_Autostart_TitleInputs */

const en_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-start Next Session`)
};

const ar_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` بدء الجلسة التالية تلقائيً`)
};

const de_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Start der nächsten Sitzung`)
};

const es_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio automático de la siguiente sesión`)
};

const fr_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage automatique de votre prochaine session`)
};

const it_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio automatico della sessione successiva`)
};

const ja_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のセッションを自動開始`)
};

const ko_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 세션 자동 시작`)
};

const pt_br_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início automático da próxima sessão`)
};

const ru_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автозапуск следующей сессии`)
};

const th_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเริ่มต้นเซสชันถัดไปโดยอัตโนมัติ`)
};

const tr_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki Oturumu Otomatik Başlat`)
};

const zh_cn_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动下一轮专注`)
};

const zh_tw_subscription_exclusive_feature_break_autostart_title = /** @type {(inputs: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動下一輪專注`)
};

/**
* | output |
* | --- |
* | "Auto-start Next Session" |
*
* @param {Subscription_Exclusive_Feature_Break_Autostart_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_break_autostart_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Break_Autostart_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Break_Autostart_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_break_autostart_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_break_autostart_title(inputs)
	return zh_tw_subscription_exclusive_feature_break_autostart_title(inputs)
});